import { render, staticRenderFns } from "./InPostWidget.vue?vue&type=template&id=75993930&"
import script from "./InPostWidget.vue?vue&type=script&lang=js&"
export * from "./InPostWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports